import gql from 'graphql-tag';
import { ActionPlanFragments } from '@getaccept/dsr-shared-new/src/api/mutual-action-plan/graphql/action-plan.fragments';
import { ActionPlanFragments as ActionPlanPublishedFragments } from './action-plan.fragments';

export class ActionPlanQueries {
  static load = gql`
    query GetActionPlans {
      getActionPlans {
        ...actionPlanFragment
      }
    }
    ${ActionPlanPublishedFragments.actionPlan}
  `;

  static loadMilestones = gql`
    query GetMilestones($actionPlanId: String!, $offset: Float, $limit: Float) {
      getMilestones(actionPlanId: $actionPlanId, offset: $offset, limit: $limit) {
        ...milestonesFragment
      }
    }
    ${ActionPlanFragments.milestones}
  `;

  static loadMilestone = gql`
    query Milestone($actionPlanId: String!, $milestoneId: String!) {
      milestone(actionPlanId: $actionPlanId, milestoneId: $milestoneId) {
        ...milestoneFragment
      }
    }
    ${ActionPlanFragments.milestone}
  `;

  static loadTask = gql`
    query Task($actionPlanId: String!, $milestoneId: String!, $taskId: String!) {
      task(actionPlanId: $actionPlanId, milestoneId: $milestoneId, taskId: $taskId) {
        ...taskFragment
      }
    }
    ${ActionPlanFragments.task}
  `;
}
